<template>
  <div>
    
    <!-- ShiftStore -->

  </div>
</template>

<script>
import _ from 'lodash'
import ShiftStoreQueryMixin from './Mixins/ShiftStoreQueryMixin.vue'
import ShiftStorePivotMixin from './Mixins/ShiftStorePivotMixin.vue'
import ShiftStoreToBeRefactoredMixin from './Mixins/ShiftStoreToBeRefactoredMixin.vue'
import storeGetDataMixin from '@/mixins/storeGetDataMixin.vue'
  
export default {
  name: 'ShiftStore',
  mixins : [ShiftStoreQueryMixin, ShiftStorePivotMixin, ShiftStoreToBeRefactoredMixin, storeGetDataMixin],
  data () { return { 
      // day: '2020-01-01',
      numOfShifts: 200,
      selectedKey:'Shift',
      timestamps:{
          dateKey:'week',
          from: undefined,
          to: undefined,
      },
      data: {},
      // pivotedData:{},
      
      defaultDataEntryObj: {
        cashiers:[], 
        safe:0,
        coin:0,
        backupTerminal:0,
        // charges:0,
        deductions:{
          charges: 0,
          thefts: 0,
          errors: 0,
          uncollected: 0,
          pos_errors: 0,
          pre_pay_errors: 0,
        },
        payAtPump:0,
        note:'',
      },
    } 
  },
  created(){
    this.$locations.forEach(location=>{
      this.$set(this.data, location, {isLoading: false, shifts:undefined});
    })
    // console.log('Initial Shift Store Data', this.data)
  },
  
  methods:{
    // double check if this works
    debounceLoadData(location, numOfShifts=10){
      console.log(`Shift Store Debounce loading Data for ${location}`);
      return _.debounce(() => {
        this.loadData(location, numOfShifts)
      }, 800)
    },
    // loadDataOld: function(){
    //   if (!document.hasFocus())
    //     return;
      
    //   //Strip timezone from ts 
    //   //Not sure if this is needed since I'm get the ts from the server
    //   let  from = moment(this.timestamps.from).startOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
    //   let  to = moment(this.timestamps.to).endOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
    //   //Skip if from and to are the same
    //   if(from === to){
    //     console.log('skipping')
    //     return
    //   }

    //   console.log('from to', from, to);

    //   this.$locations.forEach(location=>{
    //     const data = { location, from: this.timestamps.from, to: this.timestamps.to, options:this.queryOptions }
    //     this._getData('/GetShifts', 'shifts', location, data, this.postLoadData)
    //   })
    // },

    // _getData(endpoint, dataKey, location){
    //   if(this.data[location].isLoading === true) {
    //     //Trying to fixing debouncing problem
    //     console.log('Skipped Loading Data for store',this.$options.name, location)
    //     return;
    //   }
    //   console.time(`${location} Get Shifts - Fetch`)
    //   this.data[location][dataKey] = []
    //   this.data[location].isLoading = true;
    //   this.$axios.post(endpoint, { location, from: this.timestamps.from, to: this.timestamps.to, options:this.queryOptions }).then((r)=>{
    //     if(this.postLoadData){
    //       this.postLoadData(location, r)
    //     }else {
    //       this.data[location].isLoading = false;
    //       this.data[location][dataKey] = r.data;
    //       this.$emit('input', this.data)
    //     }
    //     console.timeEnd(`${location} Get Shifts - Fetch`)
    //   });
    // },
    postLoadData(location, s){
      console.time(`${location} Get Shifts - Processing`)
      let defaultData = JSON.stringify(this.defaultDataEntryObj)
      s.data.forEach(r => r.shiftsJson = r.shiftsJson === null || r.shiftsJson === undefined  ? {RowID: r.RowID, data:JSON.parse(defaultData)} : {RowID: r.shiftsJson.RowID, data:JSON.parse(r.shiftsJson.data)})
      //210303 Handle Data Migration from old to new
      s.data.forEach(r => r.shiftsJson.data = {...JSON.parse(defaultData), ...r.shiftsJson.data});

      // Add day key 
      // Note: I hardcoded the 6 hours timezone adjustment
      const midDay = (s,e) => (moment(s).toDate().getTime() + moment(e).toDate().getTime()) / 2
      s.data.forEach(r=>r.day = moment(midDay(r.StartDateTime, r.EndDateTime)).add(6, 'hours').startOf('day').toDate())
      
      // Filter out shifts that have not ended
      s.data = s.data.filter(r=>r.EndDateTime !== null)

      // Filter out days not in the timestamps
      s.data = s.data.filter(r=>moment(r.day).isBetween(moment(this.timestamps.from), moment(this.timestamps.to), undefined, '[]'))
      
      this.data[location].shifts = s.data
      this.data[location].isLoading = false;
      console.timeEnd(`${location} Get Shifts - Processing`)
    },
    loadData(numOfShifts=this.numOfShifts){
      console.log(`Shift Store loadData`);
      this.$locations.forEach(location => this.loadDataForLoaction(location, numOfShifts))
    },
    loadDataForLoaction(location, numOfShifts=10) {
      console.log(`Shift Store loadData for ${location}`);
      if(!this.timestamps.from || !this.timestamps.to)
        return;
      // options.include = [
        //   { model: 'departments', attributes: ['Description'], required : true, include:['category']}, 
      // ];
      console.log(`Loading Data for ${location}`);
      const options = this.query(numOfShifts);
      // this.data[location].shifts = [];
      // this.data[location].isLoading = true;
      
      this._getData(`/api/${location}/shifts`, 'shifts', location, {params:options}, this.postLoadData)

      // this.$axios.get(`/api/${location}/shifts`, {params:options}).then((s)=>{
        
      //   if (Array.isArray(s.data) && s.data.length > 0)
      //     // console.log(JSON.stringify(Object.keys(s.data[0])));

      //   if (!Array.isArray(s.data) ){
      //     console.log('ERROR', options)
      //     return;
      //   }
        
      //   this.postLoadData(location, s)
      // });
    },

    saveEdit(location, row){
      console.log(`Saving Data for ${location}`);
      const updateData = {
        RowID : row.RowID,
        data : JSON.stringify(row.shiftsJson.data)
      }
      this.$axios.patch(`/api/${location}/shiftsJson/`, updateData).then((r)=>{
        //Should Do Something Here
        console.log('Should Do Something Here', r)
      });
    },

    totals(location){
      const result = []
      let totals = this.$math.sumKeys(this.pivotedData[location].shifts)
      totals.day = 'Total'
      totals = this.$util.deleteObjectProperties(totals, ['StartDateTime', 'EndDateTime', 'note'])
      result.push(totals);
      // console.log('ShiftStore totals', result)
      return result;
    },

    subtotals(location){
      let subtotals = this.$math.subtotalsForKey(this.pivotedData[location].shifts, 'day')
      return subtotals;
    },
    
  },
  computed:{

    
  }
}
</script>